<script setup lang="ts">
import { PhCheck, PhX } from '@phosphor-icons/vue'
import type { PasswordRequirement } from '@/composables/usePasswordRequirements'

defineProps<{
    requirements: PasswordRequirement[]
}>()
</script>

<template>
    <div class="flex flex-col gap-2 text-sm">
        <div
            v-for="(requirement, index) in requirements"
            :key="index"
            class="flex items-center gap-2"
            :class="requirement.passed ? 'text-green-600' : 'text-gray-600'">
            <component
                :is="requirement.passed ? PhCheck : PhX"
                class="size-4" />
            <span>{{ requirement.label }}</span>
        </div>
    </div>
</template>
